function LogIcon(props) {
  return (
    <svg {...props} fill='#000000' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35 41'>
      <g id='Raggruppa_518' data-name='Raggruppa 518' transform='translate(-1517 -559)'>
        <path
          id='Tracciato_447'
          data-name='Tracciato 447'
          d='M74.692,36.615V61.846A3.154,3.154,0,0,1,71.538,65H55.769a1.577,1.577,0,0,1,0-3.154H71.538V38.192H62.077A1.577,1.577,0,0,1,60.5,36.615V27.154H43.154V41.346a1.577,1.577,0,1,1-3.154,0V27.154A3.154,3.154,0,0,1,43.154,24H62.077a1.577,1.577,0,0,1,1.116.461L74.231,35.5a1.577,1.577,0,0,1,.461,1.116M63.654,35.038h5.655l-5.655-5.655Z'
          transform='translate(1477.308 535)'
        />
        <text id='LOG' transform='translate(1517 593)' fontSize='14' fontFamily='Roboto-Bold, Roboto' fontWeight='700'>
          <tspan x='0' y='0'>
            LOG
          </tspan>
        </text>
      </g>
    </svg>
  )
}

export default LogIcon
